import rootSaga from './sagas';

export { SCOPE, FILTERS_THRESHOLD_SCOPE, TRENDS_THRESHOLD_SCOPE } from './types';

export { default as reducer } from './reducer';

export const sagas = [...rootSaga];
